import React from 'react';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { GlassPageBg } from '../../../../../components/glass';
import { NfseAmbiente } from '../../../../../types/nfseEmissao';
import { NfseIsland } from './NfseIsland';
import { C } from './ui';

/** Moldura de toda tela do módulo: aurora, faixa da marca, Dynamic Island e entrada suave. */
export function NfsePage({
  wide,
  ambiente,
  children,
}: {
  wide?: boolean;
  ambiente?: NfseAmbiente;
  children: React.ReactNode;
}) {
  return (
    <GlassPageBg
      sx={{
        backgroundColor: '#F3F7FA',
        backgroundImage: `
          radial-gradient(at 8% 0%, #CDEBFB 0%, transparent 45%),
          radial-gradient(at 50% 40%, #E2F1FD 0%, transparent 55%),
          radial-gradient(at 96% 20%, #D6E6FB 0%, transparent 45%)
        `,
      }}
    >
      <Box h="4px" bg={C.brand600} />
      <Box maxW={wide ? '1240px' : '1120px'} mx="auto" w="full" px={{ base: 4, md: 8 }} pb={12}>
        <NfseIsland ambiente={ambiente} />
        <motion.div
          initial={{ opacity: 0, y: 14, filter: 'blur(6px)' }}
          animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
        >
          <Flex direction="column" gap="30px" pt={10}>
            {children}
          </Flex>
        </motion.div>
      </Box>
    </GlassPageBg>
  );
}

/** Blocos que entram em cascata, 70 ms de distância. */
export function Cascata({ i, children }: { i: number; children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, delay: 0.07 * i, ease: [0.16, 1, 0.3, 1] }}
      style={{ height: '100%' }}
    >
      {children}
    </motion.div>
  );
}

export function Carregando({ texto }: { texto?: string }) {
  return (
    <Flex direction="column" align="center" gap={3} py={16}>
      <Spinner color={C.brand700} thickness="3px" />
      {texto && (
        <Text fontSize="13px" color={C.subtle}>
          {texto}
        </Text>
      )}
    </Flex>
  );
}
